module.exports = __webpack_public_path__ + "img/yd-sz-img.76dfe743.jpg";